import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { TRACKING_ID } from '../../utils/trackingId';
import { useLocation } from 'react-router';
import { useEnv } from '../../context/EnvironmentContext/EnvironmentContext';
import { Enviroment } from '@partnerconnect-monorepo/types/EnvironmentVariables';

const PAGE_VIEW_EVENT = 'page_view';

export const usePageTracking = () => {
  const env = useEnv();

  const location = useLocation();

  useEffect(() => {
    if (env.environment === Enviroment.PROD) {
      TagManager.initialize({ gtmId: TRACKING_ID });
      TagManager.dataLayer({
        dataLayer: {
          event: PAGE_VIEW_EVENT,
          page: location.pathname + location.search
        }
      });
    }
  }, [env.environment, location.pathname, location.search]);
};
